// extracted by mini-css-extract-plugin
export var container = "_ar-0";
export var icon = "_ar-1";
export var text = "_ar-2";